import PropTypes from 'prop-types';

import { useTransl } from 'shared/lib/i18n';

import GenericFormContainer from '../Forms/GenericFormContainer';

import {
  allowedCardNumber,
  formatSelect,
  lengthValidation64,
  onlyNumeric,
  required,
} from '../Forms/utils';
import { getFullName } from '../Person/utils';

import {
  DATE_PICKER,
  MESSAGE,
  REACT_SELECT_INPUT,
  STYLED_TEXT,
} from '../Forms/fieldTypes';

const AccessCardFormComponent = (props) => {
  const {
    form,
    onSubmit,
    initialValues,
    preselectedPerson,
    personsProperties,
    selectedPersonId,
    selectedPerson,
    isRegistered,
    hasVerifiedPhoneNumber,
    batchOptions,
    selectedBatch,
    isCreate,
    buildings,
    personOptions,
    selectedBuildingId,
    isLyazonType,
    selectedType,
    batch,
  } = props;

  const { t } = useTransl();

  const formData = [
    {
      keyName: 'accessCardBatch',
      label: t('title.accessCardBatch'),
      fieldType: REACT_SELECT_INPUT,
      options: batchOptions,
      validate: [required],
    },
    {
      keyName: 'number',
      label: t('title.number'),
      fieldType: STYLED_TEXT,
      validate: isLyazonType
        ? [required, lengthValidation64]
        : [required, onlyNumeric, allowedCardNumber],
      isHidden: !selectedBatch,
    },
    {
      keyName: 'scanCode',
      label: t('title.scanCode'),
      fieldType: STYLED_TEXT,
      validate: [],
      isHidden: isCreate,
      disabled: true,
    },
    {
      keyName: 'effectiveDate',
      label: t('title.effectiveDate'),
      fieldType: DATE_PICKER,
      validate: [required],
    },
    {
      keyName: 'validUntil',
      label: t('title.validUntil'),
      fieldType: DATE_PICKER,
      validate: [],
    },
    {
      keyName: 'building',
      label: t('title.building'),
      fieldType: REACT_SELECT_INPUT,
      options: formatSelect(Object.values(buildings)),
      validate: [required],
      disabled: !selectedType,
    },
    {
      keyName: 'person',
      label: t('title.person'),
      fieldType: REACT_SELECT_INPUT,
      options: personOptions,
      validate: [required],
      disabled: preselectedPerson,
      isHidden: !selectedBuildingId,
    },
    {
      keyName: 'message',
      fieldType: MESSAGE,
      value: t('accessCard.intercomNote', { who: getFullName(selectedPerson) }),
      isHidden:
        !selectedPersonId ||
        (selectedPersonId && isRegistered) ||
        (selectedPersonId && !isRegistered && hasVerifiedPhoneNumber),
    },
    {
      keyName: 'properties',
      label: t('title.properties'),
      fieldType: REACT_SELECT_INPUT,
      options: personsProperties,
      validate: [required],
      isHidden: !selectedPersonId,
      disabled: preselectedPerson,
      multi: true,
    },
    {
      keyName: 'type',
      label: t('title.type'),
      fieldType: STYLED_TEXT,
      validate: [required],
      isHidden: true,
    },
  ];
  return (
    <GenericFormContainer
      form={form}
      formData={formData}
      onSubmit={onSubmit}
      initialValues={initialValues}
      title={isCreate ? t('accessCard.add') : t('accessCard.update')}
      submitText={isCreate ? t('accessCard.add') : t('accessCard.update')}
      batch={batch}
      isSkeletonDisabled
    />
  );
};
AccessCardFormComponent.defaultProps = {
  personsProperties: [],
  selectedPersonId: null,
  isRegistered: false,
  batchOptions: [],
  selectedBatch: null,
  isCreate: false,
  buildings: {},
  personOptions: [],
  selectedBuildingId: null,
  selectedPerson: null,
  hasVerifiedPhoneNumber: false,
  preselectedPerson: null,
  selectedType: null,
};
AccessCardFormComponent.propTypes = {
  form: PropTypes.string.isRequired,
  onSubmit: PropTypes.func.isRequired,
  initialValues: PropTypes.instanceOf(Object).isRequired,
  preselectedPerson: PropTypes.instanceOf(Object),
  personsProperties: PropTypes.instanceOf(Array),
  selectedPersonId: PropTypes.number,
  selectedPerson: PropTypes.instanceOf(Object),
  isRegistered: PropTypes.bool,
  hasVerifiedPhoneNumber: PropTypes.bool,
  batchOptions: PropTypes.instanceOf(Array),
  selectedBatch: PropTypes.number,
  isCreate: PropTypes.bool,
  buildings: PropTypes.instanceOf(Object),
  personOptions: PropTypes.instanceOf(Array),
  batch: PropTypes.instanceOf(Object),
  selectedBuildingId: PropTypes.number,
  isLyazonType: PropTypes.bool.isRequired,
  selectedType: PropTypes.string,
};

export default AccessCardFormComponent;
